import Cookies from "js-cookie";

export const QN_REDIRECT_COOKIE = "qnRedirectUrl";

export const setRedirectUrlCookie = () => {
  Cookies.set(QN_REDIRECT_COOKIE, encodeURIComponent(window.location.href), {
    path: "/",
  });
};

export const getRedirectUrl = () => {
  const redirectUrl = Cookies.get(QN_REDIRECT_COOKIE);

  Cookies.remove(QN_REDIRECT_COOKIE, {
    path: "/",
  });

  if (!redirectUrl) {
    return "/";
  }

  try {
    const decodedUrl = decodeURIComponent(redirectUrl);
    const url = new URL(decodedUrl, window.location.origin);

    return url.origin === window.location.origin
      ? `${url.pathname}${url.search}${url.hash}`
      : "/";
  } catch {
    return "/";
  }
};
